var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue, Watch } from 'nuxt-property-decorator';
import { ValidationProvider } from 'vee-validate';
import { namespace } from 'vuex-class';
import { PATHS, API_PATHS } from '~/router';
import AppForm from '~/components/forms/form.vue';
const app = namespace('app');
let FormRegistrationStep1 = class FormRegistrationStep1 extends Vue {
    constructor() {
        super(...arguments);
        this.PATHS = PATHS;
        this.formData = {
            registration: {
                identifier: '',
                terms_of_use: false
            }
        };
    }
    onSkipCodeChanged(newSkipCode) {
        if (newSkipCode) {
            delete this.formData.registration.code;
        }
        else {
            this.formData.registration.code = '';
        }
    }
    onRegistrationDataChanged(newRegistrationData) {
        this.formData.registration = { ...this.formData.registration, ...newRegistrationData };
    }
};
__decorate([
    app.State
], FormRegistrationStep1.prototype, "globalPages", void 0);
__decorate([
    app.Getter
], FormRegistrationStep1.prototype, "portal", void 0);
__decorate([
    Prop()
], FormRegistrationStep1.prototype, "registrationData", void 0);
__decorate([
    Prop({ type: String, required: false, default: API_PATHS.AUTH.REGISTER.STEP1 })
], FormRegistrationStep1.prototype, "formAction", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: false })
], FormRegistrationStep1.prototype, "isIdAustriaRegistration", void 0);
__decorate([
    Watch('isIdAustriaRegistration', { immediate: true, deep: true })
], FormRegistrationStep1.prototype, "onSkipCodeChanged", null);
__decorate([
    Watch('registrationData', { immediate: true, deep: true })
], FormRegistrationStep1.prototype, "onRegistrationDataChanged", null);
FormRegistrationStep1 = __decorate([
    Component({
        components: {
            AppForm,
            ValidationProvider
        }
    })
], FormRegistrationStep1);
export default FormRegistrationStep1;
